// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4023) return "static/css/4023.8151e7327b4e75235228.css";
	if (chunkId === 7564) return "static/css/sender.2af543adeeab849813bb.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"322f1cc3ca0f05a8be68","1412":"83971b4df2c901ec0bdb","3380":"e7369794cddb97eeca78","4514":"e7369794cddb97eeca78","6877":"322f1cc3ca0f05a8be68","6952":"322f1cc3ca0f05a8be68","8107":"a1717806cb26dd0b7c20","9010":"e7369794cddb97eeca78"}[chunkId] + ".chunk.css";
};